module.exports = __webpack_public_path__ + "03b381.png?887c3cac6337586d19c36677653bcf0d";